export default "__VITE_ASSET__Dvj9OcOl__"